import { ElementType, PropsWithChildren } from "react";
import { cardHeaderClasses } from "./CardHeader.style";
import Typography from "@/Typography";

export type CardHeaderProps = {
  className?: string;
  component?: ElementType;
  heading?: string;
  subHeading?: string;
};
const CardHeader = (props: PropsWithChildren<CardHeaderProps>) => {
  const {
    className,
    component: Component = "div",
    heading,
    subHeading,
    ...rest
  } = props;
  return (
    <Component {...rest} className={cardHeaderClasses({ class: className })}>
      {Boolean(heading) && <Typography variant="h3">{heading}</Typography>}
      {Boolean(subHeading) && (
        <Typography variant="subtitle1">{subHeading}</Typography>
      )}
      {props.children}
    </Component>
  );
};
export default CardHeader;
